import { PerformanceProfileRecord } from '../../performance/performance-profile-record';
import { RpcObservableRequestContext } from '../rpc-observable-request';
import { RpcObservableResultContext } from '../rpc-observable-result';

/**
 * RPC Performance request name and version.
 */
export class RpcObservablePerformanceKey {
    public static command = 'PerformanceObservable';
    public static configCommand = 'PerformanceConfigObservable';
    public static version = '0.2.0';
}

/**
 * Rpc observable performance data.
 */
export interface RpcObservablePerformanceRequest extends PerformanceProfileRecord, RpcObservableRequestContext {
}

export type RpcObservablePerformanceResult = RpcObservableResultContext;

export interface RpcObservablePerformanceError extends RpcObservableResultContext {
    error: Error;
}

/**
 * Rpc observable performance set data.
 */
export interface RpcObservablePerformanceConfigRequest extends RpcObservableRequestContext {
    enabled: boolean;
}
